/**
 * SVG fractal-noise grain overlay, fixed to the viewport, drifting with scroll.
 * Sits behind content (z -10), above the body background.
 */
export default function NoiseOverlay() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 -z-10 opacity-[0.06] mix-blend-soft-light"
    >
      <svg
        className="h-[200%] w-[200%] animate-grain-drift"
        xmlns="http://www.w3.org/2000/svg"
      >
        <filter id="grain-noise">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.85"
            numOctaves="2"
            stitchTiles="stitch"
          />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#grain-noise)" />
      </svg>
    </div>
  );
}
